import script from "./ScavRosterContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./ScavRosterContacts.vue?vue&type=script&setup=true&lang=js"

import "./ScavRosterContacts.vue?vue&type=style&index=0&id=de7dd292&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de7dd292"]])

export default __exports__